// extracted by mini-css-extract-plugin
var _1 = "V_QR5";
var _2 = "urrFl";
var _3 = "SVU1Z";
var _4 = "B06bH";
var _5 = "umDC5";
export { _1 as "base", _2 as "inspector", _3 as "main", _4 as "secondary", _5 as "sidebar" }
